import {
  GET_DOC_VIEWER_ORDER_DOC,
  GET_DOC_VIEWER_ORDER_DOC_OK,
  GET_ORDER_DOC_ERR,
  DO_ORDER_DOC_SINGLE_CLEANUP,
  SIGN_ORDER_DOC,
  SIGN_ORDER_DOC_OK,
  SIGN_ORDER_DOC_ERR,
  DO_ORDER_DOC_SIGNING_CLEANUP,
} from "./actionTypes";
import { GetOrderDocResponse, GetOrderDocSignersResponse, GetOrderDocSigningsResponse, GetSignaturesResponse, SignOrderDocRequest, SignOrderDocResponse } from "~/types/backend";

/********** SINGLE **********/

export const getDocViewerOrderDoc = (id: number) => ({
  type: GET_DOC_VIEWER_ORDER_DOC,
  payload: { id },
});

export const getDocViewerOrderDocOk = (docResponse: GetOrderDocResponse, signersResponse: GetOrderDocSignersResponse, signingsResponse: GetOrderDocSigningsResponse, signaturesResponse: GetSignaturesResponse) => ({
  type: GET_DOC_VIEWER_ORDER_DOC_OK,
  payload: { docResponse, signersResponse, signingsResponse, signaturesResponse },
});

export const getOrderDocErr = (error: Error) => ({
  type: GET_ORDER_DOC_ERR,
  payload: { error },
});

export const doOrderDocSingleCleanup = () => ({
  type: DO_ORDER_DOC_SINGLE_CLEANUP,
});

/********** SIGNING **********/

export const signOrderDoc = (data: SignOrderDocRequest, id: number) => ({
  type: SIGN_ORDER_DOC,
  payload: { data, id },
});

export const signOrderDocOk = (response: SignOrderDocResponse) => ({
  type: SIGN_ORDER_DOC_OK,
  payload: { response },
});

export const signOrderDocErr = (error: Error) => ({
  type: SIGN_ORDER_DOC_ERR,
  payload: { error },
});

export const doOrderDocSigningCleanup = () => ({
  type: DO_ORDER_DOC_SIGNING_CLEANUP,
});